// Catalogo de areas de notificacion: color, etiqueta e icono por portafolio.
//
// Punto unico de configuracion. Para dar de alta un modulo nuevo basta con
// agregar su portafolio al arreglo del area correspondiente; si no aparece
// aqui, cae en el area "informativo" y la fila se pinta en gris sin romperse.
//
// El color NO se define en este archivo: cada area expone una clave que el
// SCSS traduce con las variables del proyecto (.nt-area--credito, etc.).

import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BarChartIcon from "@mui/icons-material/BarChart";
import CampaignIcon from "@mui/icons-material/Campaign";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export const AREAS_NOTIFICACION = {
    credito: { clave: "credito", etiqueta: "Credito", icono: CreditCardIcon },
    cobranza: { clave: "cobranza", etiqueta: "Cobranza", icono: ReceiptLongIcon },
    ventas: { clave: "ventas", etiqueta: "Ventas", icono: BarChartIcon },
    informativo: { clave: "informativo", etiqueta: "Informativo", icono: CampaignIcon },
    alerta: { clave: "alerta", etiqueta: "Alerta", icono: WarningAmberIcon },
    whatsapp: { clave: "whatsapp", etiqueta: "WhatsApp", icono: WhatsAppIcon },
};

// Portafolios que envia el backend, agrupados por area.
const PORTAFOLIOS_POR_AREA = {
    credito: [
        "SOLICITUD DE CREDITO",
        "CREDITO CONDICIONADO",
        "REESTRUCTURACION CREDITO",
        "REFERENCIAS BANCARIAS",
        "EXPEDIENTE DIGITAL",
    ],
    cobranza: [
        "COBRANZA",
        "PRESTAMO CLIENTES",
        "PAGOS",
        "DASHBOARD COBRANZA",
    ],
    ventas: [
        "SCORECARD",
        "SEMINUEVOS",
        "PEDIDOS FACTURADOS",
        "SOLICITUDES CREDITO FACTURADAS",
        "COTIZACIONES",
    ],
    informativo: [
        "LISTADO DE PRECIO SEMINUEVOS",
        "LISTADO DE PRECIO PA",
        "CATALOGOS",
        "COMUNICADOS",
        "REFACCIONES",
    ],
    alerta: [
        "CARTERA VENCIDA",
        "SOLICITUD RECHAZADA",
        "AUDITORIA",
        "INCIDENCIAS",
    ],
};

// Normaliza para comparar sin acentos, sin dobles espacios y sin mayusculas.
const normalizar = (texto) =>
    String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .replace(/\s+/g, " ")
        .toUpperCase();

// Indice inverso portafolio -> area, armado una sola vez.
const INDICE_AREAS = Object.keys(PORTAFOLIOS_POR_AREA).reduce((indice, area) => {
    PORTAFOLIOS_POR_AREA[area].forEach((portafolio) => {
        indice[normalizar(portafolio)] = area;
    });
    return indice;
}, {});

/**
 * Devuelve el area de una notificacion a partir de su portafolio.
 * Nunca regresa undefined: el area "informativo" es el respaldo.
 */
export const obtenerAreaNotificacion = (portafolio) => {
    const area = INDICE_AREAS[normalizar(portafolio)];
    return AREAS_NOTIFICACION[area] || AREAS_NOTIFICACION.informativo;
};
